var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.height)?_c('LutticaScrollBar',{ref:"dropMenuBar",attrs:{"scrollingX":false,"height":_vm.height}},[_c('ul',{staticClass:"ivu-dropdown-menu"},[_vm._t("default")],2)]):_c('ul',{staticClass:"ivu-dropdown-menu"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }